import { email, ext, max, required } from "@vee-validate/rules";
import { configure, defineRule } from "vee-validate";

import { i18n } from "./i18n";

// Localize default messages
configure({
  // eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys
  generateMessage: (context) => i18n.global.t(`validation.${context.rule.name}`)
});

// Install rules
defineRule("email", email);
defineRule("max", max);
defineRule("required", required);
defineRule("ext", ext);

defineRule("max_array", (value, [max]) => {
  if (!Array.isArray(value) || !Object.hasOwnProperty.call(value, "length")) {
    return false;
  }

  return value.length <= max;
});

const isEmptyArray = (arr) => Array.isArray(arr) && arr.length === 0;

const includes = (collection, item) => collection.indexOf(item) !== -1;

const testEmpty = (value) =>
  isEmptyArray(value) || includes([false, null, undefined], value) || !String(value).trim().length;

defineRule("required_if", (value, [target, values]) => {
  let required;

  if (values && values.length) {
    if (!Array.isArray(values) && typeof values === "string") {
      values = [values];
    }

    // eslint-disable-next-line
    required = values.some((val) => val == String(target).trim());
  } else {
    required = !testEmpty(target);
  }

  if (!required) {
    return {
      valid: true,
      required
    };
  }

  return {
    valid: !testEmpty(value),
    required
  };
});
